module.exports = __webpack_public_path__ + "img/file01.a97a1769.png";